import React, { useRef, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
// Alert, message
import { Button, Row, Col, Input, Spin } from 'antd'
import { formatMessage, formatMessageNew, handleChange, languageObj } from '../../utils/common'
import { getTagTypeByUpc, apiTagValidation, readNfcDataForPhone, fullBindForPhone, reset } from '../../services/tag/tag'
import { modalError, modalSuccess, modalWarning, destroyModal } from '../../utils/modalUtils'
import './PhoneLayout.less'

let macErrorModal = null
let errorModal = null
let successModal = null
let errorNum = 0
let intervalRef = null
let intervalFlag = false
const labelStyle = { textAlign: 'right', display: 'flex', alignItems: 'center' }
const FullTag = () => {
  const inputRef = useRef(null)
  const commonStore = useSelector(state => state.commonStore)
  const languageState = useSelector(state => state.commonStore.language)
  const macState = useSelector(state => state.commonStore.mac)
  const deviceCode = useSelector(state => state.commonStore.deviceCode)
  const rfPath = useSelector(state => state.commonStore.rfPath)
  const [spinLoading, setSpinLoading] = useState(false)
  const [upcValue, setUpcValue] = useState('')
  const [nfcValue, setNfcValue] = useState('')
  const [actualTagType, setActualTagType] = useState('')
  const [requiredTagType, setRequiredTagType] = useState([])
  // const [isBlur, setIsBlur] = useState(false)
  const [upcInputReadOnly, setUpcInputReadOnly] = useState(false)

  const queryHeader = {
    isRF: true,
    mac: macState,
    deviceCode
  }

  // 页面初始化
  useEffect(() => {
    inputRef.current.focus({ cursor: 'all' })
    // 监听全局键盘事件
    window.addEventListener('keydown', onWindowKeyDown)
    return () => {
      // 移除全局键盘事件
      window.removeEventListener('keydown', onWindowKeyDown)
      // 清除定时器
      clearInterval(intervalRef)
      console.log('清除定时器')
      // 请求reset
      resetUidFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 语言切换
  useEffect(() => {
    // 防止切换语言后重复NFC报错不切换
    if (intervalRef) clearInterval(intervalRef)
    commonStore.languageObj = languageObj[languageState]
    // 启用定时器
    startInterval()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])

  // NFC读取到值就校验
  useEffect(() => {
    if (nfcValue?.length !== 0) onValidationTag()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nfcValue])

  // 启用定时器 获取NFC的值
  useEffect(() => {
    if (!macState) return showMacError()
    getNfcByTimes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalFlag])

  // 弹出报错 upc失焦点
  useEffect(() => {
    inputRef.current.blur()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorModal])

  // 启用定时器
  const startInterval = () => {
    intervalFlag = !intervalFlag
  }

  // 未能识别到中间件
  const showMacError = () => {
    if (errorNum !== 0) return
    errorNum = 1
    console.log('macAddress err-Fulltag')
    macErrorModal = modalWarning(
      {
        content: formatMessageNew('languageObj.nsptagLocale.rfMacError')
      },
      () => {
        errorNum = 0
      }
    )
  }

  const resetUidFun = () => {
    reset({}, queryHeader)
      .then(res => {
        console.log(res)
      })
      .catch(error => {
        console.log(error)
      })
  }

  // 获取NFC的定时器
  const getNfcByTimes = () => {
    if (intervalRef) clearInterval(intervalRef)
    intervalRef = setInterval(() => {
      // 读取NFC
      getNfcValue()
    }, 650)
  }

  // 获取NFC
  const getNfcValue = () => {
    const params = {
      Connector: {
        ConnStr: 'RDType=RD5200;CommType=USB;AddrMode=0;SerNum='
      },
      OperatorName: 'InventoryOperator',
      InventoryOperator: {
        bHF: 1,
        Ant: [1],
        bISO14443A: false,
        bISO15693: true,
        bISO14443B: false
      }
    }
    readNfcDataForPhone(params, queryHeader)
      .then(response => {
        if (response.errorcode === '200') {
          const { tagType, uid } = response.resultData
          console.log('tagType', tagType)
          setActualTagType(tagType && tagType !== 'null' ? tagType : '')
          setNfcValue(uid && uid !== 'null' ? uid : '')
        } else {
          setActualTagType('')
          setNfcValue('')
          clearInterval(intervalRef)
          showMacError()
        }
      })
      .catch(error => {
        console.log(error)
        clearInterval(intervalRef)
        showMacError()
      })
  }

  // 全局键盘事件
  const onWindowKeyDown = e => {
    if (e.keyCode === 13) {
      if (macErrorModal) {
        destroyModal(macErrorModal)
        macErrorModal = null
        errorNum = 0
      }
      // 关闭 错误提示弹窗
      if (errorModal) {
        destroyModal(errorModal)
        errorModal = null
        errorNum = 0
        resetValues()
      }
      // 关闭 成功提示弹窗
      if (successModal) {
        destroyModal(successModal)
        successModal = null
        resetValues()
      }
    } else if (e.keyCode === 113) {
      // F2
      resetValues()
    }
  }

  // 获取 required tag type
  const getTagTypeFun = () => {
    if (!upcValue) {
      return
    }
    let params = {
      upc: upcValue
    }
    getTagTypeByUpc(params, queryHeader, true)
      .then(res => {
        if (res.errorCode === '200') {
          let types = []
          if (res.resultData) {
            const { tagType, tagTypeDesc } = res.resultData || {}
            const tagTypeArr = tagType.split(',')
            const tagTypeDescArr = tagTypeDesc.split(',')
            types = tagTypeArr.map((item, index) => {
              return `${item} - ${tagTypeDescArr[index]}`
            })
          }
          setRequiredTagType(types)
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  // UPC 输入框回车事件
  const onInputKeyDownUpc = e => {
    if (e.keyCode !== 13) return
    // 为什么要加这个判断？可能是因为阻止键盘弹起
    inputRef.current.blur()
    getTagTypeFun()
    onBinding()
  }

  // UPC 输入框聚焦事件
  const onInputFocusUpc = e => {
    setUpcInputReadOnly(true)
    setTimeout(() => {
      setUpcInputReadOnly(false)
    }, 100)

    // setIsBlur(false)
  }

  // NFC 输入框回车事件
  const onInputKeyDownNfc = e => {
    if (e.keyCode !== 13) return
    // 为什么要加这个判断？可能是因为阻止键盘弹起
    inputRef.current.blur()
    onValidationTag()
  }

  // 校验标签是否有效
  const onValidationTag = () => {
    console.log('校验标签是否有效')
    apiTagValidation({ tagUid: nfcValue }, queryHeader)
      .then(res => {
        // 有效
        if (res.errorCode === '200') onBinding()
      })
      .catch(error => {
        // 关闭定时器
        clearInterval(intervalRef)
        if (errorNum !== 0) return
        errorNum = 1
        let str = ''
        switch (error.errorCode) {
          case '421':
            str = 'languageObj.nsptagLocale.NFCUIDInvalid'
            break
          case '442':
            str = 'languageObj.nsptagLocale.NFCUIDDisabled'
            break
          default:
            str = 'languageObj.httpLocale.requestError'
        }
        errorModal = modalError(
          {
            content: formatMessageNew(str)
          },
          () => {
            errorModal = null
            errorNum = 0
            resetValues()
          }
        )
      })
  }

  // 绑定
  const onBinding = () => {
    inputRef.current.blur()
    if (!upcValue || !nfcValue) return
    // 发送请求前关闭定时器
    clearInterval(intervalRef)
    setSpinLoading(true)
    const params = {
      actualTagType,
      nfcUid: nfcValue,
      upc: upcValue,
      rfPath
    }
    fullBindForPhone(params, queryHeader)
      .then(res => {
        setSpinLoading(false)
        resetUidFun()
        successModal = modalSuccess(
          {
            content: formatMessage(commonStore, 'languageObj.nsptagLocale.tagSuccess')
          },
          resetValues
        )
      })
      .catch(error => {
        setSpinLoading(false)
        resetUidFun()
        if (errorNum !== 0) return
        let str = ''
        console.log(error)
        switch (error.errorCode) {
          case '416':
            str = formatMessageNew('languageObj.nsptagLocale.uidEmptyError')
            break
          case '417':
            str = formatMessageNew('languageObj.nsptagLocale.uidExistsError')
            break
          case '418':
            str = formatMessageNew('languageObj.nsptagLocale.upcEmptyError')
            break
          case '419':
            str = formatMessageNew('languageObj.nsptagLocale.skuNotExistError')
            break
          case '422':
            str = formatMessageNew('languageObj.nsptagLocale.nfcHasBoundError')
            break
          case '435':
          case '415':
            str = formatMessageNew('languageObj.nsptagLocale.illegalUpcError')
            break
          case '439':
            str = formatMessageNew('languageObj.nsptagLocale.workstationError')
            break
          case '442':
            str = formatMessageNew('languageObj.nsptagLocale.NFCUIDDisabled')
            break
          case '905':
            str = `${formatMessageNew('languageObj.nsptagLocale.tagTypeNotMatch')} '${
              error.resultData.requiredTagType
            }'`
            break
          default:
            str = formatMessageNew('languageObj.httpLocale.requestError')
        }
        console.log(str)
        errorModal = modalError(
          {
            content: str
          },
          () => {
            errorModal = null
            errorNum = 0
            resetValues()
          }
        )
      })
  }

  const onUpcBlur = () => {
    console.log('blur')
    if (errorModal) return
    setTimeout(() => {
      inputRef.current && inputRef.current.focus({ cursor: 'all' })
    }, 500)
  }

  const resetValues = () => {
    resetUidFun()
    clearInterval(intervalRef)
    setUpcValue('')
    setNfcValue('')
    setActualTagType('')
    setRequiredTagType([])
    inputRef.current.focus({ cursor: 'all' })
    // 启用定时器
    startInterval()
  }

  return (
    <div className="h100 full-tag-wrapper">
      <Spin spinning={spinLoading} size="large">
        {/* 报错提示 */}
        <Row>
          <Col span={9} style={labelStyle} className="fs-15">
            UPC:
          </Col>
          <Col span={15}>
            <Input
              className="fs-15"
              ref={inputRef}
              value={upcValue}
              allowClear
              readOnly={upcInputReadOnly}
              placeholder={`${formatMessage(commonStore, 'languageObj.nsptagLocale.pleaseScan')}UPC`}
              onChange={e => {
                console.log('e', e)
                handleChange(e, { setState: setUpcValue })
              }}
              onBlur={onUpcBlur}
              onKeyUp={e => onInputKeyDownUpc(e)}
              onFocus={e => onInputFocusUpc(e)}
            />
          </Col>
        </Row>
        <Row className="mt15">
          <Col span={10} style={labelStyle} className="fs-15">
            {formatMessage(commonStore, 'languageObj.nsptagLocale.requiredTagType')}
          </Col>
          <Col span={14} className="fs-15">
            {requiredTagType.map((item, index) => (
              <p key={index} style={{ margin: '5px 0' }}>
                {item}
              </p>
            ))}
          </Col>
        </Row>
        <Row className="mt15">
          <Col span={9} style={labelStyle} className="fs-15">
            NFC UID：
          </Col>
          <Col span={15}>
            <Input
              className="fs-15"
              value={nfcValue}
              allowClear
              readOnly
              placeholder={`${formatMessage(commonStore, 'languageObj.nsptagLocale.pleaseScan')}NFC`}
              onChange={e => handleChange(e, { setState: setNfcValue })}
              onKeyUp={e => onInputKeyDownNfc(e)}
            />
          </Col>
        </Row>
        <Row className="mt15">
          <Col span={9} style={labelStyle} className="fs-15">
            {formatMessage(commonStore, 'languageObj.nsptagLocale.actualTagType')}
          </Col>
          <Col span={15} className="fs-15">
            {actualTagType}
          </Col>
        </Row>
        <Row>
          <Col span={24} className="mt15" style={{ textAlign: 'center' }}>
            <Button type="primary" onClick={resetValues} className="phone-btn reset-btn">
              {`${formatMessage(commonStore, 'languageObj.nsptagLocale.reset')} (F2)`}
            </Button>
          </Col>
        </Row>
      </Spin>
    </div>
  )
}
export default FullTag
